// =============================================================================
// src/features/analytics/analytics-insights-live-store.ts - Estado das edicoes
// VIVAS dos Cards Taticos: lista de refs (desc), data ativa e cache do
// RESULTADO DO PARSE por data (nunca re-parseia). Store separada da
// analytics-live-store de proposito (2026-07-28): aquela e patch espelho-de-
// mock; esta e lista + cursor + cache — semanticas diferentes. Sem DOM, sem
// fetch (loader em analytics-insights-edition-loader; hidratacao no bootstrap).
// =============================================================================

import type { AnalyticsInsightParseResult } from './analytics-insights-edition-parser';
import type { AnalyticsInsightEditionRef } from './analytics-insights-types';

let insightEditionRefs: readonly AnalyticsInsightEditionRef[] = [];
let activeInsightEditionDate: string | null = null;
const parsedInsightDocByDate = new Map<string, AnalyticsInsightParseResult>();

/** Registra a lista vinda do Hasura: ordena desc por data e deduplica
 * (1a ocorrencia vence — o SQL ja manda generated_at desc dentro da data).
 * A edicao mais RECENTE vira a ativa. */
export function applyAnalyticsInsightEditionList(editionRefs: readonly AnalyticsInsightEditionRef[]): void {
  const refByDate = new Map<string, AnalyticsInsightEditionRef>();
  for (const editionRef of editionRefs) {
    if (!refByDate.has(editionRef.editionDate)) refByDate.set(editionRef.editionDate, editionRef);
  }
  insightEditionRefs = [...refByDate.values()].sort((firstRef, secondRef) =>
    secondRef.editionDate.localeCompare(firstRef.editionDate),
  );
  activeInsightEditionDate = insightEditionRefs[0]?.editionDate ?? null;
}

export function analyticsInsightEditionRefs(): readonly AnalyticsInsightEditionRef[] {
  return insightEditionRefs;
}

export function analyticsInsightActiveEditionRef(): AnalyticsInsightEditionRef | null {
  return insightEditionRefs.find((editionRef) => editionRef.editionDate === activeInsightEditionDate) ?? null;
}

export function setAnalyticsInsightActiveEditionDate(editionDate: string): void {
  if (insightEditionRefs.some((editionRef) => editionRef.editionDate === editionDate)) {
    activeInsightEditionDate = editionDate;
  }
}

/** Ref vizinha na LISTA (desc): 'prev' = edicao mais antiga, 'next' = mais
 * recente. Anda por indice — lacunas de calendario (26/07 sem edicao) sao
 * puladas naturalmente. Null na ponta. */
export function analyticsInsightAdjacentEditionRef(
  direction: 'prev' | 'next',
): AnalyticsInsightEditionRef | null {
  const activeIndex = insightEditionRefs.findIndex(
    (editionRef) => editionRef.editionDate === activeInsightEditionDate,
  );
  if (activeIndex < 0) return null;
  return insightEditionRefs[direction === 'prev' ? activeIndex + 1 : activeIndex - 1] ?? null;
}

export function cacheAnalyticsInsightParsedDoc(editionDate: string, parsed: AnalyticsInsightParseResult): void {
  parsedInsightDocByDate.set(editionDate, parsed);
}

export function cachedAnalyticsInsightParsedDoc(editionDate: string): AnalyticsInsightParseResult | null {
  return parsedInsightDocByDate.get(editionDate) ?? null;
}

/** true quando ha edicoes vivas — o digest mostra a nav e deixa o estatico. */
export function analyticsInsightsLiveActive(): boolean {
  return insightEditionRefs.length > 0;
}

/** Volta ao estado estatico (usado pelo caminho de erro da hidratacao). */
export function clearAnalyticsInsightEditions(): void {
  insightEditionRefs = [];
  activeInsightEditionDate = null;
  parsedInsightDocByDate.clear();
}

export function __resetAnalyticsInsightsLiveForTests(): void {
  clearAnalyticsInsightEditions();
}
